module.exports = {
  client: "dlc",
  details: {
    account: "9969230000",
    address: "123 MAIN ST FLR 2 ",
    name: "LAST,FIRST M",
    status: "Active",
    user: "6603380000",
  },
  expires_in: "3600",
  issued_at: "2021-07-02T16:40:58.606Z",
  token:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRLZXkiOiJkbGMiLCJ2YWxpZEFjY291bnQiOnRydWUsImNvbXBhbnlJZCI6NCwiZGl2aXNpb25JZCI6NywicHJvamVjdEFwcElkIjoxMiwiY29uZmlnIjp7ImRibmFtZSI6ImRsYyJ9LCJpYXQiOjE2MjgxMTY0MDEsImV4cCI6MTYyODEyMDAwMSwiaXNzIjoicHJlZmVyZW5jZS1wb3J0YWwtYXBpIn0.0ITDNR2lKdm0O83NAGeXGIMvMeizHZQnTMloNnJduhk",
};
